import { normalizeDates as o } from "./_lib/normalizeDates.js";
function i(a, r, n) {
  const [e, t] = o(
    n?.in,
    a,
    r
  );
  return e.getFullYear() === t.getFullYear() && e.getMonth() === t.getMonth();
}
export {
  i as default,
  i as isSameMonth
};
